import React, { useContext, useEffect } from "react";
import {
  ContItems,
  SelectPuglinToPostBtn,
  DivBtnCerrar
} from "../../../../../assets/css/components/admin/marketplace-to-marketplace/modal-post-product/StepsStyle";
import { BtnGeneral } from "../../../../../assets/css/components/admin/marketplace-to-marketplace/modal-post-product/ModalContStyles";
import { GlobalContext } from "../../../../../contexts/GlobalContext";
import verifyThirdPartyUser from "../../../../general/VerifyThirdPartyUser";

export default function SelectPluginToPost({
  currentPlugin,
  setCurrentPlugin,
  nextStep,
}) {
  const globalContext = useContext(GlobalContext);

  const selectedpluginPost = (v) => {
    setCurrentPlugin(v);
    nextStep();
  };

  const getPluginName = (entId, key) => {
    let name = null;
    // IDMC 
    if (entId === "5f59092f5f8c84465e058171") {
      switch (key) {
        case "fl":
          name = "Falabella";
          break;
        case "vtex":
          name = "Vtex";
          break;
        case "ml":
          name = "Mercadolibre";
          break;
        default:
          return null;
      }
      //TECNIMUNDO
    } else if (entId === "5f1378dcef2f752aeda16673") {
      switch (key) {
        case "ml":
          name = "Mercadolibre";
          break;
        case "cashea":
          name = "Cashea";
          break;
        default:
          return null;
      }
      //DK TIENDAS
    } else if (entId === "60e6f0d203ee66e57951c8ea") {
      switch (key) {
        case "ml":
          name = "Mercadolibre";
          break;
        case "cashea":
          name = "Cashea";
          break;
        default:
          return null;
      }
      //Licores Factory
    } else if (entId === "5f0eaeb398c3f413782defb5") {
      switch (key) {
        case "ml":
          name = "Mercadolibre";
          break;
        default:
          return null;
      }
    } 
    return name;
  };

  const renderPluginButtons = () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) return null;

    const plugins = [
      { key: "ml", name: "Mercado Libre", className: "ml" },
      { key: "cashea", name: "Cashea", className: "cashea" },
      { key: "vtex", name: "VTEX", className: "vtex" },
      { key: "fl", name: "FALABELLA", className: "fl" },
    ];

    return plugins.map(plugin => {
      const pluginName = getPluginName(entId, plugin.key);
      if (!pluginName) return null;

      return (
        <SelectPuglinToPostBtn
          key={plugin.key}
          active={currentPlugin === plugin.key}
          onClick={() => {
            selectedpluginPost(plugin.key);
          }}
          className={plugin.className}
        >
          {pluginName}
        </SelectPuglinToPostBtn>
      );
    });
  };

  return (
    <ContItems>
      <DivBtnCerrar>
        <BtnGeneral
          bgc='#7367F0'
          color='#FFF'
          onClick={() => globalContext.setModalPostProduct(false)}
        >
          Cerrar
        </BtnGeneral>
      </DivBtnCerrar>

      {renderPluginButtons()}
    </ContItems>
  );
}
